// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deletion-warning-banner {
  background: linear-gradient(135deg, #f39c12 0%, #e74c3c 100%);
  color: white;
  padding: 16px 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 1001;
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.banner-content {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.banner-icon {
  flex-shrink: 0;
}

.banner-icon svg {
  width: 24px;
  height: 24px;
  color: white;
}

.banner-text {
  flex: 1 1;
  min-width: 200px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.banner-text strong {
  font-size: 16px;
  font-weight: 600;
}

.banner-text span {
  font-size: 14px;
  opacity: 0.95;
}

.banner-actions {
  display: flex;
  gap: 12px;
  flex-shrink: 0;
}

.btn-cancel-deletion,
.btn-view-details {
  padding: 8px 16px;
  border: 2px solid white;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.btn-cancel-deletion {
  background: white;
  color: #e74c3c;
}

.btn-cancel-deletion:hover:not(:disabled) {
  background: #f8f9fa;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.btn-cancel-deletion:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.btn-view-details {
  background: transparent;
  color: white;
}

.btn-view-details:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: translateY(-1px);
}

/* Add padding to body when banner is visible to prevent content from being hidden */
body.has-deletion-banner {
  padding-top: 80px;
}

@media (max-width: 768px) {
  body.has-deletion-banner {
    padding-top: 120px; /* More padding on mobile due to stacked layout */
  }

  .deletion-warning-banner {
    padding: 12px 16px;
  }

  .banner-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .banner-text {
    width: 100%;
  }

  .banner-actions {
    width: 100%;
    flex-direction: column;
  }

  .btn-cancel-deletion,
  .btn-view-details {
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/DeletionWarningBanner.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,oFAAoF;AACpF;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB,EAAE,iDAAiD;EACvE;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".deletion-warning-banner {\n  background: linear-gradient(135deg, #f39c12 0%, #e74c3c 100%);\n  color: white;\n  padding: 16px 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 1001;\n  animation: slideDown 0.3s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    transform: translateY(-100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.banner-content {\n  max-width: 1400px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.banner-icon {\n  flex-shrink: 0;\n}\n\n.banner-icon svg {\n  width: 24px;\n  height: 24px;\n  color: white;\n}\n\n.banner-text {\n  flex: 1;\n  min-width: 200px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.banner-text strong {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.banner-text span {\n  font-size: 14px;\n  opacity: 0.95;\n}\n\n.banner-actions {\n  display: flex;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.btn-cancel-deletion,\n.btn-view-details {\n  padding: 8px 16px;\n  border: 2px solid white;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.btn-cancel-deletion {\n  background: white;\n  color: #e74c3c;\n}\n\n.btn-cancel-deletion:hover:not(:disabled) {\n  background: #f8f9fa;\n  transform: translateY(-1px);\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.btn-cancel-deletion:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.btn-view-details {\n  background: transparent;\n  color: white;\n}\n\n.btn-view-details:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: translateY(-1px);\n}\n\n/* Add padding to body when banner is visible to prevent content from being hidden */\nbody.has-deletion-banner {\n  padding-top: 80px;\n}\n\n@media (max-width: 768px) {\n  body.has-deletion-banner {\n    padding-top: 120px; /* More padding on mobile due to stacked layout */\n  }\n\n  .deletion-warning-banner {\n    padding: 12px 16px;\n  }\n\n  .banner-content {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .banner-text {\n    width: 100%;\n  }\n\n  .banner-actions {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .btn-cancel-deletion,\n  .btn-view-details {\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
